<template>
  <div class="gj-breadcrumb flex align-center">
    <div class="fanhui size12 color333" @click="backHandle">
      <gj-icon class="el-icon-back"></gj-icon>
      返回
    </div>
    <div class="line"></div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class=" size12 color999">
      <el-breadcrumb-item v-for="(i) in list" :key="i.name"><span @click="i.handle">{{i.name}}</span></el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "gj-breadcrumb",
  props: {
    list: {
      type: Array,
      default: function () {
        return [
          {name: '首页', handle: function () {}},
          {name: '活动管理', handle: function () {}},
          {name: '活动列表', handle: function () {}},
        ]
      }
    }
  },
  methods:{
    backHandle(){
      this.$emit('backHandle')
    }
  }
}
</script>

<style scoped lang="scss">
.gj-breadcrumb {
}

.fanhui {
  cursor: pointer;

  &:hover {
    color: #1F6EEF !important;
  }
}

.line {
  height: 12px;
  border-left: 1px solid #E4E5E6;;
  margin: 0 11.5px;
}

.el-icon-back {
  font-weight: 700;
  margin-right: 4px;
}
</style>